module.exports = __webpack_public_path__ + "img/DocmaLogo.d57aaa4d.svg";